module.exports = __webpack_public_path__ + "media/4x3/bv-78bef910.svg";